import styled from "styled-components";
import { Grid } from "@material-ui/core";

export const STPrimaryError = styled(Grid)`
   {
    && {
      font-size: 0.8rem;
      color: #f44336;
      min-height: 1em;
      line-height: 1em;
      text-align: left;
      font-weight: 400;
      padding-right: 16px;
    }
  }
`;

export const STGrid = styled(Grid)`
  && {
    padding-top: 8px;
  }
`;
